import React from 'react';
import { Button } from '../ui/button';
import { FloatingPortal, Placement, useFloating, useHover, useInteractions } from '@floating-ui/react';

interface IPopupMenuProps extends React.PropsWithChildren  {
    className?: string;
    placement?: Placement;
    delay?: {
        open: number,
        close: number
    }
    menuElements: IPopupMenuAction[];
}

export interface IPopupMenuAction {
    title: string | React.JSX.Element;
    extraClass?: string;
    variant?: "default" | "link" | "destructive" | "outline" | "secondary" | "ghost" | null | undefined;
    disabled?: boolean;
    onClick: () => void;
}

const PopupMenu = (props: IPopupMenuProps) => {
    const { children, className, delay, placement, menuElements } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        placement: placement ?? 'top',
        onOpenChange: setIsOpen
    });

    const hover = useHover(context, { delay: {
        open: delay?.open ?? 500,
        close: delay?.close ?? 125,
    }});

    const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

    return (
        <>
            {isOpen && (
                <FloatingPortal>
                    <div
                        className="floating p-4 text-sm rounded-2xl bg-slate-300 text-black-500 border outline-2 border-border-default"
                        ref={refs.setFloating}
                        style={{...floatingStyles, zIndex: 10}}
                        {...getFloatingProps()}
                    >
                        {menuElements.map(o => (
                            o?.title === 'DIV'
                                ? <div
                                    className={`w-full h-[2px] bg-slate-50 mb-1 ${o?.extraClass}`}
                                >&nbsp;</div>
                                : <Button
                                    className={`w-full bg-slate-50 mb-1 ${o?.extraClass}`}
                                    disabled={o?.disabled}
                                    variant={o?.variant ?? 'default'}
                                    onClick={() => {
                                        setIsOpen(false);
                                        o?.onClick();
                                    }}
                                >
                                    {o?.title}
                                </Button>)
                        )}
                    </div>
                </FloatingPortal>
            )}
            <div
                className={`size- justify-end items-end ${className}`}
                ref={refs.setReference}
                {...getReferenceProps()}
            >
                {children}
            </div>
        </>
    );
};

export default PopupMenu;